/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {motion} from "motion/react";

class MotionDiv extends Component {
    render() {
        let {
            initial,
            animate,
            exit,
            transition,
            style,
            className,
            children,
            whileTap,
            onClick,
            id,
            layout,
            layoutScroll,
            onMouseEnter
        } = this.props
        if (document.disableAnimations) {
            return (
                <>
                    <div
                        style={style}
                        className={className}
                        onClick={onClick}
                        onMouseEnter={onMouseEnter}
                        id={id}
                    >
                        {children}

                    </div>


                </>
            );


        }

        return (
            <>
                <motion.div
                    initial={initial}
                    animate={animate}
                    exit={exit}
                    transition={transition}
                    style={style}
                    className={className}
                    whileTap={whileTap}
                    onClick={onClick}
                    onMouseEnter={onMouseEnter}
                    id={id}
                    layout={layout}
                    layoutScroll={layoutScroll}
                >
                    {children}

                </motion.div>


            </>
        );
    }
}

MotionDiv.propTypes = {};

export default MotionDiv;